export * as share from './modules/share.js';
export * as links from './modules/links.js';
export * as fitvid from './modules/fitvid.js';
export * as fetch from './modules/fetch.js';
export { navigationClose } from './modules/navigation-close.js';
export { navigationScroll } from './modules/navigation-scroll.js';
export { AOFReferralManager } from './modules/referral.js';
export { VideoBlock } from './modules/video.js';
export const blocks = {}; // this is necessary for webpack's export modules - see webpack.config.js
